import React from 'react';
import TranscriptParagraph from './TranscriptParagraph';
import './TranscriptContainer.css';

const TranscriptContainer = ({ paragraphs, showLoader, interimTranscription }) => {
  return (
    <div className="transcript-container">
      {paragraphs.map((paragraph, index) => (
        <TranscriptParagraph key={index} paragraph={paragraph} />
      ))}
      {interimTranscription && (
        <div className="interim-transcription">
          <pre dangerouslySetInnerHTML={{__html: interimTranscription}}/>
        </div>
      )}
      {showLoader && (
        <div className="loader-container">
          <div className="loader"></div>
        </div>
      )}
    </div>
  );
};

export default TranscriptContainer;
